/// <reference path="./env.d.ts" />

// Environment Configuration Interface
interface EnvConfig {
  API_BASE_URL: string;
  APP_URL: string;
  GLOBAL_API_URL: string;
  ENTITY_URL: string;
  SALES_URL: string;
  FINANCE_REPORTS_URL: string;
  SALES_INTELLIGENCE_URL: string;
  PERMISSION_URL: string;
  PERMISSION_KEY: string;
  PRODUCT_CODE: string;
}

// Dynamic Environment Configuration Function for Vite
function getEnvConfig(): EnvConfig {
  return {
    API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://map.dbi360.com',
    APP_URL: import.meta.env.VITE_APP_URL || 'https://app.dbi360.com',
    GLOBAL_API_URL: import.meta.env.VITE_GLOBAL_API_URL || 'https://globalapi.dbi360.com',
    ENTITY_URL: import.meta.env.VITE_ENTITY_URL || 'https://entity.dbi360.com',
    SALES_URL: import.meta.env.VITE_SALES_URL || 'https://sales.dbi360.com',
    FINANCE_REPORTS_URL: import.meta.env.VITE_FINANCE_REPORTS_URL || 'https://financereports.dbi360.com',
    SALES_INTELLIGENCE_URL: import.meta.env.VITE_SALES_INTELLIGENCE_URL || 'https://salesintelligence.dbi360.com',
    PERMISSION_URL: import.meta.env.VITE_PERMISSION_URL || '',
    PERMISSION_KEY: import.meta.env.VITE_PERMISSION_KEY || '',
    PRODUCT_CODE: import.meta.env.VITE_PRODUCT_CODE || '',
  };
}

// Centralized Environment Export
export const env = getEnvConfig();

// Legacy exports for backward compatibility (deprecated - use env object instead)
export const API_URL = env.API_BASE_URL;
export const APP_URL = env.APP_URL;
export const GLOBAL_API_URL = env.GLOBAL_API_URL;
export const ENTITY_URL = env.ENTITY_URL;
export const SALES_URL = env.SALES_URL;
export const FINANCE_REPORTS_URL = env.FINANCE_REPORTS_URL;
export const SALES_INTELLIGENCE_URL = env.SALES_INTELLIGENCE_URL;
